import { Box, Typography } from '@mui/material';

export interface ProgressBarProps {
  percentage: number;
  size?: 'small' | 'medium' | 'large';
  variant?: 'fixed' | 'full-width';
}

export const getProgressColor = (value: number): string => {
  if (value < 100) return 'success.main'; // Green - under budget
  if (value === 100) return 'warning.main'; // Amber - at budget
  return 'error.main'; // Red - over budget
};

export function ProgressBar({
  percentage,
  size = 'small',
  variant = 'fixed',
}: ProgressBarProps) {
  const barHeight = size === 'small' ? 4 : size === 'medium' ? 6 : 8;
  const isFullWidth = variant === 'full-width';
  const fixedBarWidth = size === 'small' ? 70 : size === 'medium' ? 100 : 120;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: isFullWidth ? '100%' : 'auto',
      }}
    >
      {/* Background track */}
      <Box
        sx={{
          width: isFullWidth ? undefined : fixedBarWidth,
          flex: isFullWidth ? 1 : undefined,
          height: barHeight,
          bgcolor: 'grey.200',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {/* Progress fill */}
        <Box
          sx={{
            width: `${Math.min(percentage, 100)}%`,
            height: '100%',
            bgcolor: getProgressColor(percentage),
            transition: 'width 0.3s ease',
          }}
        />
      </Box>

      {/* Percentage text */}
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          minWidth: '40px',
          fontSize: '0.75rem',
          flexShrink: 0,
        }}
        color="text.secondary"
      >
        {percentage.toFixed(1)}%
      </Typography>
    </Box>
  );
}
